module.exports = __webpack_public_path__ + "static/img/item-shop-bg.b10b713.png";